import { render, staticRenderFns } from "./VisibleQuestions.vue?vue&type=template&id=4c79e6ef&"
import script from "./VisibleQuestions.vue?vue&type=script&lang=ts&"
export * from "./VisibleQuestions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports